<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-skew">
                    <img src="img/bkgrnd.jpg" class="img-fluid">
                </div>

                  <div class="d-none d-lg-block container shape-container">
                      <div class="col px-0">
                          <div class="row">
                              <div class="col-lg-12">
                                <img src="img/DevConf-polylogo-datum.png" width="100%">
                                <center>
                                <base-button tag="a" href="#inschrijven" type="light" class="mt-4" v-if="registratie">
                                    Schrijf je in!
                                </base-button>
                                <h2 v-if="announcement">
                                    <font color="#FFFFFF">
                                        {{announcement}}
                                    </font>
                                </h2>
                                </center>
                              </div>
                          </div>
                      </div>
                  </div>
            </section>
        </div>

        <section class="section pt-lg-0 mt--200">
            <div class="d-lg-none">
              <center>
                <h1 style="color:white;">29 MAART 2023</h1>
                <base-button tag="a" href="#inschrijven" type="light" class="mt-4" v-if="registratie">
                    Schrijf je in!
                </base-button>
              </center>
              <br>
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-planet" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Programma</h6>
                                    <p class="description mt-3" style="min-height: 50px;">Bekijk het programma van de vierde editie van devConf.</p>
                                    <base-button tag="a" href="/programma" type="primary" class="mt-4" v-if="programma">
                                        Bekijk het programma
                                    </base-button>
                                    <base-button tag="a" href="#" type="primary" class="mt-4 disabled" v-else>
                                        Nog niet beschikbaar
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-spaceship" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase"><s>Virtual Venue</s></h6>
                                    <p class="description mt-3" style="min-height: 50px;">Dit jaar niet virtueel, maar in de
                                        <a target="_blank" href="https://www.google.com/maps/place/Brightlands+Smart+Services+Campus/@50.8832359,5.9735466,17.63z/data=!4m13!1m7!3m6!1s0x47c0bdbc4cef434f:0x61fb2c38e29bbe68!2sSmedestraat+2,+6411+CR+Heerlen!3b1!8m2!3d50.8832156!4d5.9749357!3m4!1s0x47c0bdbc4b7af63f:0xdf424798fac7bed7!8m2!3d50.88274!4d5.9730243">
                                            Smart Services Campus
                                        </a> in Heerlen!</p>
                                    <base-button tag="a" href="#" type="success" class="mt-4 disabled" v-html="countdown">
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-ruler-pencil" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Archief</h6>
                                    <p class="description mt-3" style="min-height: 50px;">Bekijk programma's en video materiaal van voorgaande edities.</p>
                                    <base-button tag="a" href="/archief" type="warning" class="mt-4">
                                        Open Archief
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section" v-if="registratie">
            <div class="container" id="top-register">
                <div class="row row-grid align-items-center">
                  <center>
                      <div id="form-anchor" hidden></div>
                    <h3 id="inschrijven">DevConf 2023</h3>
                    <p class="lead text-muted">
                      Uitgegroeid uit onze interne kennis sessies en de wens om de Zuid-Limburgse developer community een impuls te geven. De idee&euml;n van morgen, vandaag.
                    </p>
                    <iframe id="platformFrame" width="70%" height="500px"
                    v-bind:src="registratie" scrolling="no"></iframe>
                  </center>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">
                        <iframe width="100%"
                                height="542"
                                src="https://www.youtube.com/embed/Pxfx115PSFI"
                                title="defConf 2023"
                                frameborder="0"
                                allow="accelerometer;
                                autoplay;
                                clipboard-write;
                                encrypted-media;
                                gyroscope;
                                picture-in-picture;
                                web-share"
                                allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row row-grid align-items-center">
                  <div class="col-lg-12">
                    <div class="newsbutton">
                          <base-button type="info" size="sm" contextmenu="" @click="openArticle" v-if="$isMobile()">Read more</base-button>
                          <base-button type="info" @click="openArticle" v-else>Read more</base-button>
                    </div>
                    <b-carousel
                          id="carousel-1"
                          :interval="15000"
                          v-model="slide"
                          fade
                          controls
                          indicators
                          background="#ababab"
                          style="text-shadow: 1px 1px 2px #333;">
                          <b-carousel-slide v-for="article in articles"
                            v-bind:caption="article.title"
                            v-bind:text="article.excerpt"
                            v-bind:img-src="'/img/article/'+article.image"></b-carousel-slide>
                      </b-carousel>
                  </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import variables from "../variables.js";
import VisitorAPI from "../api/PlatformAPI.js";
import Articles from "@/data/ArticleMetaData.js";
import Modal from "../components/Modal";
export default {
  name: "home",
  components: {
    Modal
  },
  data(){
    return {
      programma: false,
      countdown: " - ",
      open_date: "",
      event: false,
      eventUrl: "",
      articles: [],
      article_max_index: 0,
      slide: 0,
      registerModal: false,
      registratie: "",
      formSubmitted:false,
      message: "",
      visitor: {
        email : "",
        firstName : "",
        lastName : "",
        storagePermission : false
      },
      validation: {
        email : true,
        firstName : true,
        lastName : true,
      },
      verificationNotice: false,
      verificatieTitel: "",
      verificatieMessage: "",
      announcement: "",
      announcementText: ""
    }
  },
  mounted(){
    if (sessionStorage.registratie){
        this.registratie = sessionStorage.registratie;
    } else {
        this.registratie = variables.getVariable("registratie");
    }
    this.announcement = variables.getVariable("announcement");
    this.announcementText = variables.getVariable("announcementText");
    if (variables.getVariable("open_date")){
      this.open_date = variables.getVariable("open_date");
    }
    if (variables.getVariable("programma")){
          this.programma = true;
        }
    if (variables.getVariable("event")){
      this.event = true;
      this.eventUrl = variables.getVariable("event");
    }
    Articles.list().then(response => {
      this.article_max_index = response.data.length - 1;
      this.articles = response.data.reverse().slice(0,5);
      if (this.$isMobile()){
        this.articles = this.articles.map(function(article){
          article.excerpt = "";
          return article;
        });
      }
    });
    var registratie = this.registratie;
    window.addEventListener('message', function(e) {
        let message = e.data;
        if (message.url == "undefined"){
            return;
        }
        var frameHeight = (message.height + 10)  + 'px';
        document.getElementById("platformFrame").height = frameHeight;
        setTimeout(function(){
            document.getElementById("form-anchor").scrollIntoView({behavior: "smooth"});
        },100);
        if (message.url != registratie){
            sessionStorage.registratie = message.url;
            registratie = message.url;
            if (message.url.endsWith("bedankt")){
                setTimeout(function(){
                    console.log(1);
                    document.getElementById("top-register").scrollIntoView({behavior: "smooth"});
                    console.log(2);
                },500);
            }
        }
    } , false);
    moment.locale("nl");
    this.countdown_interval = setInterval(this.updateCountDown,1000);
  },
  methods: {
    updateCountDown(){
        if (this.open_date != ""){
            let date = moment(this.open_date);
            this.countdown = date.fromNow();
            if (date.isBefore()){
                //this.event = true;
                this.countdown = " - ";
                clearInterval(this.countdown_interval);
            }
        } else {
            this.countdown = "Gesloten";
        }
    },
    registorVisitor(){
      if (this.formSubmitted){
        return;
      }
      this.validation = {
        email : true,
        firstName : true,
        lastName : true,
      };
      this.formSubmitted = true;
      var vr = VisitorAPI.checkRegisterCommand(this.visitor);
      if (vr.valid){
        VisitorAPI.register(this.visitor).then(result => {
          console.log(result);
          if (result.status == 202){
            this.message = result.data.message;
          } else if (result.status != 200){
            this.message = "Er is iets mis gegaan met je inschrijving, probeer opnieuw of neem contact op met de organisatie.";
          } else {
            this.message = "We zijn er bijna! Er is een verificatie mailtje naar je inbox gestuurd. Gebruik deze mail om je inschrijving af te ronden.";
          }
        });
      } else {
        vr.errors.forEach((value, index) => {
            this.validation[value["path"][0]] = false;
        });
        this.formSubmitted = false;
      }
    },
    openArticle(){
      location.href = "/article/" + (this.article_max_index - this.slide);
    },
  }
};
</script>

<style>
.carousel-caption h3{
  color: white
}

.newsbutton {
  z-index:100;
  float: right;
  bottom: 10px;
  right: 50px;
  position: absolute;
}
</style>
